import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForAddComplementRequestApproval from './ModalForAddComplementRequestApproval';
import { requestForSignetApprovalStatuses } from '../../constants/globals';
import moment from 'moment';
import ReportRoundedIcon from '@material-ui/icons/ReportRounded';
import Tooltip from '@material-ui/core/Tooltip';
class RequestForSignetApprovalRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreview: false,
      showUpdateOrPreview: false,
      showDecisionCreation: false,
      showComplementRequest: false,
      showComplementRequestDesc: false,
    };
  }

  onDeleteClick = (id) => {
    const { t, gt, deleteRequestForSignetApproval } = this.props || {},
      { ConfirmDialog } = t || {},
      { confirmDelete } = ConfirmDialog || {};
    const action = () => {
      deleteRequestForSignetApproval(id);
    };
    confirmDialog(t.confirmMessage, action, confirmDelete, gt);
  };

  showModalForUpdateOrPreview = (isPreview) => {
    this.setState({ showUpdateOrPreview: true, showPreview: isPreview });
  };

  showModalDecisionCreation = () => {
    this.setState({ showDecisionCreation: true });
  };

  showModalComplementRequestCreation = () => {
    this.setState({ showComplementRequest: true });
  };

  handlePreviewClose = () => {
    this.setState({ showComplementRequest: false });
    this.props.clearComplementRequestApproval();
  };

  render() {
    const {
        index,
        requestForSignetApproval,
        enums,
        isUserProcessor,
        isUserAuthorizedPerson,
        Tooltips,
      } = this.props || {},
      {
        submitDate,
        createdAt,
        kjsMunicipality,
        id,
        decisionStatus,
        client,
        complementRequestApproval,
      } = requestForSignetApproval || {},
      { kjs, municipality } = kjsMunicipality || {},
      { uniqueNumber, pib, name } = kjs || {},
      { place } = municipality || {},
      { Status, DecisionStatus } = enums;

    const status = Status[requestForSignetApproval.status]?.text;

    let tabStyle = '';

    if (isUserAuthorizedPerson) {
      tabStyle =
        (requestForSignetApproval.status ===
          requestForSignetApprovalStatuses.REQUIRED_COMPLEMENTATION?.name &&
          requestForSignetApprovalStatuses.REQUIRED_COMPLEMENTATION?.color) ||
        (requestForSignetApproval.status ===
          requestForSignetApprovalStatuses.ACCEPTED?.name &&
          requestForSignetApprovalStatuses.ACCEPTED?.color) ||
        '';
    }
    if (isUserProcessor) {
      tabStyle =
        (requestForSignetApproval.status ===
          requestForSignetApprovalStatuses.COMPLEMENTED?.name &&
          requestForSignetApprovalStatuses.COMPLEMENTED?.color) ||
        (requestForSignetApproval.status ===
          requestForSignetApprovalStatuses.ACCEPTED?.name &&
          requestForSignetApprovalStatuses.ACCEPTED?.color) ||
        '';
    }

    const placeName = place?.name || '';
    const municipalityName = municipality?.name || '';

    const placeAndMunicipality = placeName + ' ' + municipalityName;

    const submitDateFormat = submitDate
      ? moment(submitDate).format('DD.MM.YYYY')
      : createdAt;

    const decisionStatusInfo =
      decisionStatus && DecisionStatus[decisionStatus].text;

    const clientsEmail = client?.username;

    const complementRequired =
      requestForSignetApproval?.complementRequestApproval &&
      requestForSignetApproval?.status === 'REQUIRED_COMPLEMENTATION';

    const iconColor = complementRequired ? '#a9454f' : '#CCCCCC';

    const iconTooltip = complementRequired ? Tooltips.note : Tooltips.noteEmpty;

    const iconAction = complementRequired
      ? this.showModalComplementRequestCreation
      : () => {};

    const requestForSignetApprovalRow = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{name}</td>
        <td>{placeAndMunicipality}</td>
        <td>{uniqueNumber}</td>
        <td>{pib}</td>
        <td>{submitDateFormat}</td>
        <td className={tabStyle}>{status}</td>
        <td>{decisionStatusInfo}</td>
        <td>{clientsEmail}</td>
        <td>
          <Tooltip title={iconTooltip} placement="top" arrow={true}>
            <ReportRoundedIcon
              onClick={iconAction}
              fontSize="large"
              style={{ color: `${iconColor}` }}
              className="complement-required"
            />
          </Tooltip>
        </td>
        <td>
          <Link to={`/requestForSignetApprovalProcessingView/${id}`}>
            <i className="fas fa-edit fa-2x" />
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {requestForSignetApprovalRow}
        {this.state.showComplementRequest && (
          <ModalForAddComplementRequestApproval
            handleAdd={this.handleAddComplementRequestApproval}
            handleClose={this.handlePreviewClose}
            show={this.state.showComplementRequest}
            requestForSignetApproval={requestForSignetApproval}
            complementRequestApproval={complementRequestApproval}
            signal={true}
            findLastComplementRequestApprovalByRequestId={
              this.props.findLastComplementRequestApprovalByRequestId
            }
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(
  RequestForSignetApprovalRow,
  'RequestForSignetApprovalRow'
);
